import { ErrorResponse, NumberDate, Timestamp, TuettuKieli } from '@lemon/core/model/common'
import { Bic } from '@lemon/core/service/bic.service'

/** Käyttäjätyyppi, jonka puolesta suostumus luodaan. */
export enum PSUType {
  BUSINESS = 'business',
  PERSONAL = 'personal',
}

export interface EnableBankingLemonaidOauthStartRequest {
  subtypeName: string
  /** Optional IBAN for prefilling in bank's auth flow */
  iban?: string
  kieli: TuettuKieli
  beta?: boolean
  psuType: PSUType
}

export interface EnableBankingAspspSubtype {
  name: string
  psuTypes: PSUType[]
  // logoSrc: string
  maximumValidity: number
}

export interface EnableBankingAspspList {
  bankSubtypes: Partial<Record<Bic, EnableBankingAspspSubtype[]>>
  updated: Timestamp
  country: 'FI'
}

export interface EnableBankingLemonaidOauthStartResponse extends ErrorResponse<'unknown-error' | 'missing-data'> {
  redirectUrl: string
}

export interface EnableBankingAuthoriseSessionRequest {
  code: string
  userAgent: string
}

export interface EnableBankingOauthAuthoriseSessionResponse extends ErrorResponse {}

export interface SyncJobData {
  start: NumberDate
  end: NumberDate
  iban: string
}
